export const categoryIllustrations = {
  'Salutations et expressions courantes': '👋',
  'Nombres': '🔢',
  'Temps': '📅',
  'Animaux': '🐘',
  'Famille': '👨‍👩‍👧‍👦',
  'Nourriture': '🍽️',
  'Couleurs': '🎨',
  'Corps': '🧑',
  'Verbes': '🏃‍♂️',
 
};

export default categoryIllustrations ; 